import { render, staticRenderFns } from "./MiuVipAuth.vue?vue&type=template&id=44560811&scoped=true"
import script from "./MiuVipAuth.vue?vue&type=script&lang=js"
export * from "./MiuVipAuth.vue?vue&type=script&lang=js"
import style0 from "./MiuVipAuth.vue?vue&type=style&index=0&id=44560811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44560811",
  null
  
)

export default component.exports